import store from "../store";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {getImagePromiseFromLayout} from "./getCanvasImageFromLayout";
import {getQuoteVisualizerType, switchToNewVisualizerType} from "./visualizerSwitchingFunctions";
import {getRoomImageFromQtCategory} from "./categorySwitchingFunctions";
import {setQuotes} from "../actions/roomsFunctions";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {getTotalPrice} from "./helpers";
import {setVisualizerIsChanging} from "../actions/serverFunctions";
import {switchToWizardItem} from "../bvcomponents/qkbPages/materialsWizard/useChangeWizardStepRoute";
import workspace from "../bvcomponents/sqft/components/canvas/core/workspace";
import {
  deleteCartItemsThatAreMissingInSQFTCalcData,
  updateQuoteWithSQFTData
} from "../bvcomponents/sqft/helpers/sqftQuotesHelper";
import {prepareSQFTData} from "../bvcomponents/sqft/components/canvas/core/workspace/workspaceDataMapper";

/**
 * @param quoteIndex {number}
 * @param fakeLayout {object}
 * @param forLocalStorage {boolean}
 * @param nextVisualizerType {string}
 * @param bvImage {string}
 * returns updated quote object
 */
export const getQuoteInfo = async (quoteIndex, fakeLayout = null, forLocalStorage = false, nextVisualizerType, bvImage = "") => {
  const state = store.getState();
  const {quotes} = state.quotesState;
  const {settings} = state.fabricatorState;
  const {canvasDimensions} = state.bathroomVisualizerState;
  const quoteTotalPrice = getTotalPrice(quoteIndex);
  const quoteId = quotes[quoteIndex] && quotes[quoteIndex].quoteId ? quotes[quoteIndex].quoteId : null;
  const imageUrl = quotes[quoteIndex] && quotes[quoteIndex].imageUrl ? quotes[quoteIndex].imageUrl : null;

  const room = getQuoteVisualizerType(quoteIndex, nextVisualizerType);
  // keep old compatability without using different layouts
  const layout = fakeLayout || getCurrentLayout(settings.allowVisualizerSwitching ? room : document.kvConfig.visualizerType);

  // console.log("room", room);
  if (!forLocalStorage && !bvImage) {
    if (document.kvConfig.visualizerType !== room && quotes[quoteIndex] && quotes[quoteIndex].bvImage) {
      bvImage = quotes[quoteIndex].bvImage;
    } else {
      bvImage = await new Promise((resolve) => resolve(getImagePromiseFromLayout(layout, canvasDimensions)))
    }
  }

  return {
    quoteId, // quoteId - quoteId is passed from the backend in the getBvJobData response(in dashboard edit mode)
    imageUrl, // amazon url
    // ...quotes[activeQuoteIndex], no need for it for now
    data: layout.getActiveFeaturesAsObject(false, true, true),
    leadFeatures: layout.getActiveNames(),
    bvImage,
    layoutType: layout.type,
    room, // prevent overwriting on save
    materialCost: quoteTotalPrice.materialPrice,
    sqFtCalcData: quotes[quoteIndex] ? quotes[quoteIndex].sqFtCalcData || null : null,
    installationCost: quoteTotalPrice.installationPrice,
    installationTaxes: quoteTotalPrice.installationTaxes, // installation tax amount
    materialTaxes: quoteTotalPrice.materialTaxes, // material tax amount
    priceTaxes: quoteTotalPrice.priceTaxes, // material tax amount
    staticCanvasImage: getRoomImageFromQtCategory("", quoteIndex),
    isCreatedInSQFT: quotes[quoteIndex] ? quotes[quoteIndex].isCreatedInSQFT : false,
    isVisibleInSQFT: quotes[quoteIndex] ? quotes[quoteIndex].isVisibleInSQFT : true,
    qtCatName: quotes[quoteIndex] ? quotes[quoteIndex].qtCatName : "",
    roomMultiplier: quotes[quoteIndex] ? quotes[quoteIndex].roomMultiplier : "",
  }
};

export const updateCurrentQuote = async (quoteIndex, nextVisualizerType, forLocalStorage = false) => {
  const {quotes, activeQuoteIndex} = store.getState().quotesState;
  const indexToUpdate = Number.isInteger(quoteIndex) ? quoteIndex : activeQuoteIndex;
  const currentQuoteObject = await getQuoteInfo(indexToUpdate, null, forLocalStorage, nextVisualizerType);
  const newQuotes = [...quotes.map((q, qIndex) => (qIndex === indexToUpdate) ? currentQuoteObject : q)];
  if (!forLocalStorage) {
    store.dispatch(setQuotes(newQuotes));
  }
  return newQuotes
};

// /**
//  * @param quotes {array}
//  * @param activeQuoteIndex {number}
//  * returns updated quotes array
//  */
// export const updateAllQuotes = async (quotes, activeQuoteIndex) => {
//   console.log("quotes", quotes);
//   let newQuotes = [];
//   for (const [quoteIndex, quoteObject] of quotes.entries()) {
//     let newQuote = null;
//     if (quoteIndex !== activeQuoteIndex && quoteObject.data) {
//       let fakeLayout = null;
//       const layout = getCurrentLayout();
//       fakeLayout = cloneDeep(layout);
//       fakeLayout.type = quoteObject.data.layout_type;
//       fakeLayout.scene = quoteObject.data.scene;
//       fakeLayout.getFeatures(true).forEach(parentGroup => {
//         parentGroup.layout = fakeLayout;
//         parentGroup.relatedItems.forEach(relItem => {
//           relItem.getParent = () => parentGroup;
//         })
//       });
//       await fakeLayout.selectLayout(layout.type, layout.type, null, layout.scene, null, true);
//       newQuote = await getQuoteInfo(quoteIndex, fakeLayout);
//     } else {
//       newQuote = await getQuoteInfo(quoteIndex);
//     }
//     newQuotes.push(newQuote);
//   }
//   console.log("newQuotes", newQuotes);
//   store.dispatch(setQuotes(newQuotes));
//   return newQuotes
// };

export const setNewActiveQuote = async (index, newQuotes) => {
  if (!newQuotes) {
    newQuotes = store.getState().quotesState.quotes;
  }
  const newQuote = newQuotes[index];
  if (newQuote && (newQuote.layoutType || newQuote.layoutType === 0) && newQuote.data) {
    loaderEnable();
    if (newQuote.room !== document.kvConfig.visualizerType) {
      await switchToNewVisualizerType(newQuote.room, false)
    }
    const layout = getCurrentLayout();
    const bvState = newQuote.data;
    const {wizardIsActive} = store.getState().wizardState;
    if (wizardIsActive) {
      // change selectedWizardValues!
      switchToWizardItem(null, null, null, null, false);
    }
    return layout.setItemsFromBvState(bvState)
        .then(() => {
          loaderDisable();
          store.dispatch(setVisualizerIsChanging(false))
        });
  }
  return Promise.resolve()
};

export const deleteCartItemFromSQFTCalcData = async (cItem) => {
  if (cItem.sqftIds && cItem.sqftIds.length) {
    const state = store.getState();
    const quotes = state.quotesState.quotes;
    const cItemQuote = quotes[cItem.currentQuote];

    //create workspace and remove items as if they were removed from sqft
    workspace.import(cItemQuote.sqFtCalcData);
    [...cItem.sqftIds].forEach(sqftId => {
      workspace.removeFeatureBySQFTId(sqftId);
    })

    //save sqft calc data to quote
    const sqftCalcData = await prepareSQFTData();
    updateQuoteWithSQFTData(sqftCalcData, cItem.currentQuote);

    //remove cartItems that was attached features like edges and backsplashes
    deleteCartItemsThatAreMissingInSQFTCalcData();
  }
}
